module.exports = __webpack_public_path__ + "fonts/Poppins-MediumItalic.9e911c68.ttf";